import { metricKeys } from '@pulse/metrics';
import { getMetricDisplayName } from '@utils/metrics';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { AXIS_NAME, ENGAGEMENT } from '@utils/metrics/engagementMetrics';

const METRIC = metricKeys;

export const BOOLEAN_METRICS = {
  EI: {
    [metricKeys.VideoStartFailures]: {
      dimension: 'IS_VIDEO_START_FAILURE',
      metric: metricKeys.VideoStartFailures,
    },
    [metricKeys.VideoStartFailuresTech]: {
      dimension: 'IS_VIDEO_START_FAILURE_TECH',
      metric: metricKeys.VideoStartFailuresTech,
    },
    [metricKeys.VideoStartFailuresBusiness]: {
      dimension: 'IS_VIDEO_START_FAILURE_BUSINESS',
      metric: metricKeys.VideoStartFailuresBusiness,
    },
    [metricKeys.VideoPlaybackFailures]: {
      dimension: 'IS_VIDEO_PLAYBACK_FAILURE',
      metric: metricKeys.VideoPlaybackFailures,
    },
    [metricKeys.VideoPlaybackFailuresTech]: {
      dimension: 'IS_VIDEO_PLAYBACK_FAILURE_TECH',
      metric: metricKeys.VideoPlaybackFailuresTech,
    },
    [metricKeys.VideoPlaybackFailuresBusiness]: {
      dimension: 'IS_VIDEO_PLAYBACK_FAILURE_BUSINESS',
      metric: metricKeys.VideoPlaybackFailuresBusiness,
    },
    [metricKeys.ExitBeforeVideoStarts]: {
      dimension: 'ExitBeforeVideoStart',
      metric: metricKeys.ExitBeforeVideoStarts,
    },
    [metricKeys.ExitDueToCIR]: {
      dimension: 'IS_EXIT_DUE_TO_CIR',
      metric: metricKeys.ExitDueToCIR,
    },
  },
  AI: {},
  APP: {},
  ODP: {},
  ECO_SERVER: {},
}[CURRENT_PRODUCT_MODE];

export const getDistributionMetrics = () =>
  ({
    EI: {
      [METRIC.RebufferingRatio]: [
        {
          dimension: ENGAGEMENT.LifeRebufferingRatio,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'ratio',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.RebufferingRatio }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
        {
          dimension: ENGAGEMENT.LifeRebufferingRatio,
          metric: METRIC.AverageLifePlayingTimeMins,
          yAxisUnit: 'min',
          xAxisUnit: 'ratio',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.RebufferingRatio }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.AverageLifePlayingTimeMins }),
        },
      ],
      [METRIC.ConnectionInducedRebufferingRatio]: [
        {
          dimension: ENGAGEMENT.LifeNetworkRebufferingRatio,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'ratio',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.ConnectionInducedRebufferingRatio }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
        {
          dimension: ENGAGEMENT.LifeNetworkRebufferingRatio,
          metric: METRIC.AverageLifePlayingTimeMins,
          yAxisUnit: 'min',
          xAxisUnit: 'ratio',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.ConnectionInducedRebufferingRatio }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.AverageLifePlayingTimeMins }),
        },
      ],
      [METRIC.AvgBitrate]: [
        {
          dimension: ENGAGEMENT.LifeAverageAvgBitrateKbps,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'Kbps',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.AvgBitrate }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
        {
          dimension: ENGAGEMENT.LifeAverageAvgBitrateKbps,
          metric: METRIC.AverageLifePlayingTimeMins,
          yAxisUnit: 'min',
          xAxisUnit: 'Kbps',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.AvgBitrate }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.AverageLifePlayingTimeMins }),
        },
      ],
      [METRIC.Bitrate]: [
        {
          dimension: ENGAGEMENT.LifeAvgBitrateKbps,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'Kbps',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.Bitrate }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
        {
          dimension: ENGAGEMENT.LifeAvgBitrateKbps,
          metric: METRIC.AverageLifePlayingTimeMins,
          yAxisUnit: 'min',
          xAxisUnit: 'Kbps',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.Bitrate }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.AverageLifePlayingTimeMins }),
        },
      ],
      [METRIC.Framerate]: [
        {
          dimension: ENGAGEMENT.LifeAvgFramesPerSec,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'fps',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.Framerate }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
      ],
      [METRIC.VideoRestartTime]: [
        {
          dimension: ENGAGEMENT.LifeVideoRestartTimeMs,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.VideoRestartTime }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
      ],
      [METRIC.Minutes]: [
        {
          dimension: ENGAGEMENT.LifePlayingTimeMs,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: AXIS_NAME.PLAYING_TIME,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
      ],
      [METRIC.PercentageComplete]: [
        {
          dimension: ENGAGEMENT.LifeCompletionPct,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: '%',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.PercentageComplete }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
      ],
      [METRIC.ExitBeforeVideoStarts]: [
        {
          dimension: ENGAGEMENT.LifeEBVSWaitTimeMs,
          metric: METRIC.ExitBeforeVideoStarts,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: AXIS_NAME.WAIT_TIME,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.ExitBeforeVideoStarts }),
        },
      ],
      [METRIC.VideoStartTime]: [
        {
          dimension: ENGAGEMENT.LifeJoinTimeMs,
          metric: METRIC.PlaysWithValidJoinTime,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.VideoStartTime }),
          yAxisLabel: AXIS_NAME.PLAYS,
        },
      ],
      [METRIC.NonZeroCIRREndedPlays]: [
        {
          dimension: ENGAGEMENT.LifeNetworkRebufferingEvents,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'ratio',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.NonZeroCIRREndedPlays }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
        {
          dimension: ENGAGEMENT.LifeNetworkRebufferingEvents,
          metric: METRIC.AverageLifePlayingTimeMins,
          yAxisUnit: 'min',
          xAxisUnit: 'ratio',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.NonZeroCIRREndedPlays }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.AverageLifePlayingTimeMins }),
        },
      ],
      [METRIC.ExitsDuringPreRoll]: [
        {
          dimension: ENGAGEMENT.LifePodTimebeforePrerollExitSecs,
          metric: METRIC.ExitsDuringPreRoll,
          yAxisUnit: '',
          xAxisUnit: 'sec',
          xAxisLabel: AXIS_NAME.AD_PLAYING_TIME,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.ExitsDuringPreRoll }),
        },
      ],
      [METRIC.VideoPlaybackFailures]: [
        {
          dimension: ENGAGEMENT.LifeVPFPlayingTimeMs,
          metric: METRIC.VideoPlaybackFailures,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: AXIS_NAME.PLAYING_TIME,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.VideoPlaybackFailures }),
        },
      ],
      [METRIC.VideoPlaybackFailuresTech]: [
        {
          dimension: ENGAGEMENT.LifeVPFTPlayingTimeMs,
          metric: METRIC.VideoPlaybackFailuresTech,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: AXIS_NAME.PLAYING_TIME,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.VideoPlaybackFailuresTech }),
        },
      ],
      [METRIC.VideoPlaybackFailuresBusiness]: [
        {
          dimension: ENGAGEMENT.LifeVPFBPlayingTimeMs,
          metric: METRIC.VideoPlaybackFailuresBusiness,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: AXIS_NAME.PLAYING_TIME,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.VideoPlaybackFailuresBusiness }),
        },
      ],
      [METRIC.PausedRatio]: [
        {
          dimension: ENGAGEMENT.LifePausedTimePct,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: '%',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.PausedRatio }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
      ],
      [METRIC.PausedTime]: [
        {
          dimension: ENGAGEMENT.LifePausedTimeSecs,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'sec',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.PausedTime }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
      ],
      [METRIC.LifeAvgNumBitrateSwitches]: [
        {
          dimension: ENGAGEMENT.LifeAvgNumBitrateSwitches,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'unitless',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.LifeAvgNumBitrateSwitches }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
      ],
      [METRIC.LifeJoinedAvgBitrate]: [
        {
          dimension: ENGAGEMENT.JoinedAverageBitrate,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'Kbps',
          xAxisLabel: getMetricDisplayName({ metricKey: METRIC.LifeJoinedAvgBitrate }),
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
      ],
      [METRIC.VideoStartFailures]: [
        {
          dimension: ENGAGEMENT.LifeVSFWaitTimeMs,
          metric: METRIC.VideoStartFailures,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: AXIS_NAME.WAIT_TIME,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.VideoStartFailures }),
        },
      ],
      [METRIC.VideoStartFailuresTech]: [
        {
          dimension: ENGAGEMENT.LifeVSFTWaitTimeMs,
          metric: METRIC.VideoStartFailuresTech,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: AXIS_NAME.WAIT_TIME,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.VideoStartFailuresTech }),
        },
      ],
      [METRIC.VideoStartFailuresBusiness]: [
        {
          dimension: ENGAGEMENT.LifeVSFBWaitTimeMs,
          metric: METRIC.VideoStartFailuresBusiness,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: AXIS_NAME.WAIT_TIME,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.VideoStartFailuresBusiness }),
        },
      ],
      [METRIC.ExitDueToCIR]: [
        {
          dimension: ENGAGEMENT.LifeExitRelatedCIRTimeMs,
          metric: METRIC.ExitDueToCIR,
          yAxisUnit: '',
          xAxisUnit: 'ms',
          xAxisLabel: AXIS_NAME.CIR_TIME_PRECEDING_EXIT,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.ExitDueToCIR }),
        },
      ],
      [METRIC.LifeDropFrameRatio]: [
        {
          dimension: ENGAGEMENT.LifeDropFrameEndedPlays,
          metric: METRIC.EndedPlays,
          yAxisUnit: '',
          xAxisUnit: 'ratio',
          xAxisLabel: AXIS_NAME.LifeDropFrameRatio,
          yAxisLabel: getMetricDisplayName({ metricKey: METRIC.EndedPlays }),
        },
      ],
    },
    AI: {},
    APP: {
      // TODO update these fields using @pulse/metric npm package
      // config data from this doc
      // https://conviva.atlassian.net/wiki/spaces/APP/pages/1731330116/Secondary+Metrics+and+Distribution+Metrics
      [metricKeys.AppAvgPageLoadTime]: [
        {
          dimension: 'avg_page_load_time_distribution',
          metric: 'page_load_complete_count',
          yAxisUnit: '',
          xAxisUnit: 'sec',
          xAxisLabel: 'Time Used',
          yAxisLabel: 'Page Load Complete Count',
        },
      ],
      [metricKeys.AppAvgScreenLoadTime]: [
        {
          dimension: 'avg_screen_load_time_distribution',
          metric: metricKeys.AppScreenLoads,
          yAxisUnit: '',
          xAxisUnit: 'sec',
          xAxisLabel: 'Time Used',
          yAxisLabel: 'Screen Loads Count',
        },
      ],
      [metricKeys.AverageRequestDuration]: [
        {
          dimension: 'avg_request_duration_distribution',
          metric: 'total_request_count',
          yAxisUnit: '',
          xAxisUnit: 'sec',
          xAxisLabel: 'Time Used',
          yAxisLabel: 'Total Request Count',
        },
      ],
      [metricKeys.TimeToFirstAttempt]: [
        {
          dimension: 'avg_time_to_first_attempt_distribution',
          metric: 'first_attempt_count',
          yAxisUnit: '',
          xAxisUnit: 'sec',
          xAxisLabel: 'Time Used',
          yAxisLabel: 'First Attempt Count',
        },
      ],
      [metricKeys.AppStartupTime]: [
        {
          dimension: 'app_startup_time_distribution',
          metric: 'total_app_startup_complete',
          yAxisUnit: '',
          xAxisUnit: 'sec',
          xAxisLabel: 'Time Used',
          yAxisLabel: 'App Start Up Complete',
        },
      ],
      [metricKeys.AverageMinutesPerPage]: [
        {
          dimension: 'avg_minutes_per_page_distribution',
          metric: 'life_page_page_count',
          yAxisUnit: '',
          xAxisUnit: 'min',
          xAxisLabel: 'Time Used',
          yAxisLabel: 'Page Load Count',
        },
      ],
    },
    ODP: {},
  })[CURRENT_PRODUCT_MODE];
